import AFAura from "./assets/AirFrance/AFAura.jpeg";

export const AIR_FRANCE_BACKGROUND_OPTIONS = [
  {
    label: "AF Aura",
    value: "airfrance:aura",
    url: AFAura,
  },
];

const BACKGROUND_OPTION_MAP = AIR_FRANCE_BACKGROUND_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = option;
    return acc;
  },
  {}
);

export const getClientBackgroundOptions = (client) => {
  const normalizedClient = String(client || "").toLowerCase();
  if (normalizedClient === "airfrance") {
    return AIR_FRANCE_BACKGROUND_OPTIONS;
  }
  return [];
};

export const resolveBackgroundImageUrl = (backgroundImage) => {
  const value = String(backgroundImage || "").trim();
  if (!value) return "";
  return BACKGROUND_OPTION_MAP[value]?.url || value;
};
